var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbonParentNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10.0005C10.295 10.0005 9.285 10.8605 9.05 12.0005H7C5.895 12.0005 5 11.1055 5 10.0005V5.95047C5.46346 5.85587 5.89057 5.63172 6.23172 5.30407C6.57288 4.97642 6.81408 4.5587 6.92731 4.09944C7.04054 3.64018 7.02116 3.15821 6.87141 2.70953C6.72167 2.26084 6.4477 1.86385 6.08134 1.56465C5.71497 1.26545 5.27124 1.07633 4.80168 1.01925C4.33212 0.962167 3.85601 1.03947 3.42863 1.24218C3.00125 1.44489 2.64015 1.76469 2.38727 2.16443C2.13438 2.56417 2.0001 3.02745 2 3.50047C2 4.70547 2.86 5.71547 4 5.95047V10.0005C4 11.6555 5.345 13.0005 7 13.0005H9.05C9.1446 13.4639 9.36875 13.891 9.6964 14.2322C10.0241 14.5733 10.4418 14.8145 10.901 14.9278C11.3603 15.041 11.8423 15.0216 12.2909 14.8719C12.7396 14.7221 13.1366 14.4482 13.4358 14.0818C13.735 13.7154 13.9241 13.2717 13.9812 12.8022C14.0383 12.3326 13.961 11.8565 13.7583 11.4291C13.5556 11.0017 13.2358 10.6406 12.836 10.3877C12.4363 10.1349 11.973 10.0006 11.5 10.0005ZM11.5 14.0005C10.675 14.0005 10 13.3255 10 12.5005C10 11.6755 10.675 11.0005 11.5 11.0005C12.325 11.0005 13 11.6755 13 12.5005C13 13.3255 12.325 14.0005 11.5 14.0005Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonParentNode);
export default __webpack_public_path__ + "static/media/carbon_parent-node.de8a4e625c5374f79a09c7afba91cd18.svg";
export { ForwardRef as ReactComponent };